__turbopack_context__.v({
  "asBoxes": "Row-module-scss-module__invKAa__asBoxes",
  "contentContainer": "Row-module-scss-module__invKAa__contentContainer",
  "contentContainerSwipable": "Row-module-scss-module__invKAa__contentContainerSwipable",
  "contentSwipable": "Row-module-scss-module__invKAa__contentSwipable",
});
